import React from "react";
import { useHistory } from "react-router-dom";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BotonCerrar = () => {
  const navigate = useHistory();

  const handleSalirLimpiar = () => {
    window.localStorage.removeItem("idClienteStorage");
    navigate.push("/initialHome");
  };

  return (
    <div className="closeButton-container">
      <IconButton
        aria-label="cerrar"
        size="large"
        onClick={() => {
          handleSalirLimpiar();
        }}
      >
        Cerrar
        <CloseIcon fontSize="large" />
      </IconButton>
    </div>
  );
};

export default BotonCerrar;
